import { useRef } from "react";

import { Button } from "@/ui/cva/Button";

/**
 * A button that opens the photo picker (or the camera on a phone) and hands over one photo.
 * The input accepts HEIC like create-ad's photo grid; the check converts it.
 * Medium (44px), 4px corners and no border on a fill (WHO-6534 F22, F23); "ghost" is the white
 * button on the green band (F24).
 */
export const ValueCheckPhotoButton = ({
  label,
  onPick,
  appearance = "solid",
  color = "brand",
  className,
}: {
  label: string;
  onPick: (file: File) => void;
  appearance?: "solid" | "outlined";
  color?: "brand" | "ghost";
  className?: string;
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <Button
        type="button"
        color={color}
        appearance={appearance}
        size="medium"
        className={
          appearance === "solid"
            ? `rounded border-0 ${className ?? ""}`
            : `rounded ${className ?? ""}`
        }
        onClick={() => inputRef.current?.click()}
      >
        {label}
      </Button>
      <input
        ref={inputRef}
        type="file"
        accept="image/*,.heic,.heif"
        className="hidden"
        data-testid="value-check.photo-input"
        onChange={event => {
          const file = event.target.files?.[0];
          // Cleared, so picking the same photo again still fires a change.
          event.target.value = "";

          if (file) {
            onPick(file);
          }
        }}
      />
    </>
  );
};
